import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { AlertController, ModalController } from '@ionic/angular';
import { ApiService } from 'src/app/api/api.service';
import { GlobalService } from 'src/app/api/global.service';
import { ProjectsService } from 'src/app/api/projects.service';
import { CompaniesContactsSelectPage as ContactsSelectPage } from 'src/app/modals/companies-contacts-select/companies-contacts-select.page';
import type { RepeatRules } from 'src/app/api/projects.service';
import * as dayjs from 'dayjs';
import { ApplyUseProjectDates } from '../../services/task-project-dates.util';
import { ClientStepTypes } from 'src/app/components/steps/StepTypes';
import { AddressBookComponent } from 'src/app/components/address-book/address-book.component';
import { SelectComponent as TagsSelectPage } from 'src/app/components/tags/select/select.component';
import { ManagerComponent as GroupsManagerPage } from 'src/app/components/groups/manager/manager.component';
import { SelectPage as TeamMemberSelectPage } from 'src/app/team-members/select/select.page';



@Component({
  selector: 'app-assign',
  templateUrl: './assign.page.html',
  styleUrls: ['./assign.page.scss'],
})
export class AssignPage implements OnInit {
  @ViewChild('mainContainer', { static: false }) mainContainerRef: ElementRef | undefined;
  templates: any[] = [];
  selected_projects: any = {
    selected_template: '',
    assigned_clients: [],
    assigned_companies: []
  };
  dates_valid = true;
  team_members_valid = true;
  @Input() project: any = {
    title: "",
    description: "",
    row_colour: "#FFFFFF",
    status: "0",
    assign_to_person: false,
    force_order: false,
    tasks: [],
    internal_start_date: "2023-01-07",
    internal_end_date: "2023-01-20",
    external_start_date: "2023-01-07",
    external_end_date: "2023-01-15",
    create_template: false,
    template_name: '',
    template_description: '',
    add_numbers: false,
    tags: [],
    groups: [],
    assigned_companies: [],
    assigned_clients: [],
    team_members: [],
    repeat: true,
    repeat_rules: {
      version: "1",
      // Basic settings
      frequency: 'monthly', // 'daily', 'weekly', 'monthly', 'yearly', 'custom'
      interval: 1,
      pattern: 'monthly', // Legacy field - kept for backward compatibility

      // Weekly settings
      weekdays: [false, false, false, false, false, false, false], // Sun, Mon, Tue, Wed, Thu, Fri, Sat

      // Monthly settings
      monthly_type: 'day', // 'day', 'weekday', 'special'
      months: [true, true, true, true, true, true, true, true, true, true, true, true],
      monthly_any: true,
      monthly_day: 1, // Day of month (1-31)
      monthly_ordinal: '1', // 'first', 'second', 'third', 'fourth', 'last'
      monthly_weekday: '1', // Day of week for ordinal selection
      monthly_special: 'start', // Special monthly options

      // Yearly settings
      yearly_month: 1, // Month (1-12)
      yearly_day: 1, // Day of month (1-31)
      yearly_use_ordinal: false, // Use ordinal selection instead of fixed day
      yearly_ordinal: '1', // 'first', 'second', 'third', 'fourth', 'last'
      yearly_weekday: '1', // Day of week for ordinal selection
      yearly_ordinal_month: 1, // Month for ordinal selection (1-12)

      // Custom/Advanced settings
      custom: '', // JSON or CRON-like syntax for complex schedules

      // End repeat settings
      end_type: 'never', // 'never', 'date', 'after'
      end_date: null, // End date when end_type is 'date'
      end_after: 1, // Number of occurrences when end_type is 'after'

      // Semi-monthly settings
      semi_monthly_first_day: 1,
      semi_monthly_second_day: 15,
      repeat_start_date: '2026-01-01',
      // Default: every date falls in the repeat date's own month - start dates on the start of the month,
      // end dates on the end of it ("Start/End of Month" needs the offset unit to be Month(s)).
      internal_end_offset_unit: 'month',
      internal_start_offset_unit: 'month',
      external_start_offset_unit: 'month',
      external_end_offset_unit: 'month',
      period_start_offset_unit: 'month',
      period_end_offset_unit: 'month',
      period_start_offset: 0,
      period_end_offset: 0,
      relative_date_type: "project_repeat_date",
      internal_start_offset: 0,
      internal_end_offset: 0,
      external_start_offset: 0,
      external_end_offset: 0,
      internal_start_offset_type: 'start_of_month',
      internal_end_offset_type: 'end_of_month',
      external_start_offset_type: 'start_of_month',
      external_end_offset_type: 'end_of_month',
      period_start_offset_type: 'start_of_month',
      period_end_offset_type: 'end_of_month',
      internal_start_date_before: false,
      internal_end_date_before: false,
      external_start_date_before: false,
      external_end_date_before: false,
      period_start_date_before: false,
      period_end_date_before: false,
    } as RepeatRules,
    default_billing_group: '',
    all_team_members: true,


    // New fields for enhanced project management

    period_start_date: "2023-01-07T04:00:00Z",
    period_end_date: "2023-01-07T04:00:00Z",


    // Offset unit properties

    project_status: "in-house", // 'in-house' | 'external'
    current_step_name: "",
    internal_status: "", // Planning, In Progress, Review, etc.
    client_team_member: null,
    team_leader: null,
    active_step_employee: null,
    sync_client_dates: true

  }

  constructor(private modalController: ModalController, private apiService: ApiService, private projectsService: ProjectsService, public globalService: GlobalService, private alertController: AlertController) { }

  ngOnInit() {
    this.selected_projects.assigned_clients = [];
    this.selected_projects.assigned_companies = [];
    //this.GetData();
  }

  async GetData() {
    let data: any = await this.apiService.get(`templates/projects`);
    if (data.success && data.data) {
      this.templates = data.data;
      this.templates.forEach(t => {
        if (typeof t.json_str === 'string') {
          try {
            t.json_str = JSON.parse(t.json_str);
          } catch (e) {
            t.json_str = null;
          }
        }
      });
      console.log(this.templates);
    } else {
      this.globalService.presentToastMessage(data.message, data.success);
    }

  }

  async presentSelectClientModal() {
    const modal = await this.modalController.create({
      component: AddressBookComponent,
      cssClass: 'large-modal',
      backdropDismiss: false,
      componentProps: {
        external_selection_mode: true,
        allow_client_selection: true,
        allow_non_client_selection: false,
        allow_company_selection: true,
        allow_contact_selection: true,
        allow_company_group_selection: false,
        allow_contact_group_selection: false,
        in_selected_companies: this.selected_projects.assigned_companies,
        in_selected_contacts: this.selected_projects.assigned_clients,
        expanded_clients: true
      },
    })
    modal.onDidDismiss().then((data: any) => {
      this.selected_projects.assigned_clients = [];
      this.selected_projects.assigned_companies = [];
      if (data) {
        if (data.data) {
          data.data.forEach(element => {
            if (element.is_company) {
              this.selected_projects.assigned_companies.push(element);
            } else if (element.is_contact) {
              this.selected_projects.assigned_clients.push(element);
            }
          });
        }
      }
      this.ChangeClientsOrTeamMembers();
      console.log(data);
    });
    return await modal.present()
  }

  async RemoveClient(client) {
    this.globalService.RemoveFromArray(this.selected_projects.assigned_clients, client.guid);
    this.ChangeClientsOrTeamMembers();
  }

  async RemoveCompany(company) {
    this.globalService.RemoveFromArray(this.selected_projects.assigned_companies, company.guid);
    this.ChangeClientsOrTeamMembers();
  }


  CheckIfValid() {
    let error_message = '';
    return error_message;
  }

  onUpdateDates(inc_project) {
    if (!inc_project.repeat) return;

    // Calculate project dates based on repeat start date and offsets
    let internal_start_mod = inc_project.repeat_rules.internal_start_date_before ? -1 : 1;

    let internal_end_mod = inc_project.repeat_rules.internal_end_date_before ? -1 : 1;
    let external_start_mod = inc_project.repeat_rules.external_start_date_before ? -1 : 1;
    let external_end_mod = inc_project.repeat_rules.external_end_date_before ? -1 : 1;
    let period_start_mod = inc_project.repeat_rules.period_start_date_before ? -1 : 1;
    let period_end_mod = inc_project.repeat_rules.period_end_date_before ? -1 : 1;

    inc_project.internal_start_date = dayjs(inc_project.repeat_rules.repeat_start_date)
      .add(inc_project.repeat_rules.internal_start_offset * internal_start_mod, inc_project.repeat_rules.internal_start_offset_unit)
      .format("YYYY-MM-DD");

    inc_project.internal_end_date = dayjs(inc_project.repeat_rules.repeat_start_date)
      .add(inc_project.repeat_rules.internal_end_offset * internal_end_mod, inc_project.repeat_rules.internal_end_offset_unit)
      .format("YYYY-MM-DD");

    inc_project.external_start_date = dayjs(inc_project.repeat_rules.repeat_start_date)
      .add(inc_project.repeat_rules.external_start_offset * external_start_mod, inc_project.repeat_rules.external_start_offset_unit)
      .format("YYYY-MM-DD");

    inc_project.external_end_date = dayjs(inc_project.repeat_rules.repeat_start_date)
      .add(inc_project.repeat_rules.external_end_offset * external_end_mod, inc_project.repeat_rules.external_end_offset_unit)
      .format("YYYY-MM-DD");

    // Set period_start_date and period_end_date using the same logic
    inc_project.period_start_date = dayjs(inc_project.repeat_rules.repeat_start_date)
      .add(inc_project.repeat_rules.period_start_offset * period_start_mod, inc_project.repeat_rules.period_start_offset_unit)
      .format("YYYY-MM-DD");

    inc_project.period_end_date = dayjs(inc_project.repeat_rules.repeat_start_date)
      .add(inc_project.repeat_rules.period_end_offset * period_end_mod, inc_project.repeat_rules.period_end_offset_unit)
      .format("YYYY-MM-DD");

    if (inc_project.repeat_rules.frequency === 'monthly' || inc_project.repeat_rules.frequency == 'quarterly' || inc_project.repeat_rules.frequency == 'semi-annually' || inc_project.repeat_rules.frequency == 'yearly') {

      if (inc_project.repeat_rules.internal_start_offset_type === 'start_of_month') {
        inc_project.internal_start_date = dayjs(inc_project.internal_start_date).startOf('month').format("YYYY-MM-DD");
      }
      else if (inc_project.repeat_rules.internal_start_offset_type === 'end_of_month') {
        inc_project.internal_start_date = dayjs(inc_project.internal_start_date).endOf('month').format("YYYY-MM-DD");
      }
      if (inc_project.repeat_rules.internal_end_offset_type === 'start_of_month') {
        inc_project.internal_end_date = dayjs(inc_project.internal_end_date).startOf('month').format("YYYY-MM-DD");
      }
      else if (inc_project.repeat_rules.internal_end_offset_type === 'end_of_month') {
        inc_project.internal_end_date = dayjs(inc_project.internal_end_date).endOf('month').format("YYYY-MM-DD");
      }

      if (inc_project.repeat_rules.external_start_offset_type === 'start_of_month') {
        inc_project.external_start_date = dayjs(inc_project.external_start_date).startOf('month').format("YYYY-MM-DD");
      }
      else if (inc_project.repeat_rules.external_start_offset_type === 'end_of_month') {
        inc_project.external_start_date = dayjs(inc_project.external_start_date).endOf('month').format("YYYY-MM-DD");
      }

      if (inc_project.repeat_rules.external_end_offset_type === 'start_of_month') {
        inc_project.external_end_date = dayjs(inc_project.external_end_date).startOf('month').format("YYYY-MM-DD");
      }
      else if (inc_project.repeat_rules.external_end_offset_type === 'end_of_month') {
        inc_project.external_end_date = dayjs(inc_project.external_end_date).endOf('month').format("YYYY-MM-DD");
      }

      if (inc_project.repeat_rules.period_start_offset_type === 'start_of_month') {
        inc_project.period_start_date = dayjs(inc_project.period_start_date).startOf('month').format("YYYY-MM-DD");
      }
      else if (inc_project.repeat_rules.period_start_offset_type === 'end_of_month') {
        inc_project.period_start_date = dayjs(inc_project.period_start_date).endOf('month').format("YYYY-MM-DD");
      }

      if (inc_project.repeat_rules.period_end_offset_type === 'start_of_month') {
        inc_project.period_end_date = dayjs(inc_project.period_end_date).startOf('month').format("YYYY-MM-DD");
      }
      else if (inc_project.repeat_rules.period_end_offset_type === 'end_of_month') {
        inc_project.period_end_date = dayjs(inc_project.period_end_date).endOf('month').format("YYYY-MM-DD");
      }
    }


  }

  // SelectedTemplateChange() {
  //   console.log("Selected Template Changed", this.selected_projects.selected_template);
  //   let selected = this.templates.find(t => t.guid === this.selected_projects.selected_template);
  //   console.log("Selected Template Object", selected);
  //   this.project = JSON.parse(JSON.stringify(selected.json_str));
  //   this.project.assigned_clients = this.selected_projects.assigned_clients;
  //   this.project.assigned_companies = this.selected_projects.assigned_companies;
  //   this.projectsService.FixStartDate(true, this.project.repeat_rules);
  // }

  CheckIfProjectValid() {
    let error_message = '';
    if (this.project.tasks.length == 0) error_message += 'You must have at least one task in the project.\n';
    if (!this.project.title || this.project.title.length <= 0) error_message += 'You must have a title for the project.\n';

    if (this.selected_projects.assigned_clients.length == 0 && this.selected_projects.assigned_companies.length == 0) error_message += 'You must assign at least one contact or company to the project.\n';
    if (this.project.is_internal && this.projectsService.ProjectHasExternalSteps(this.project)) {
      error_message += 'This project cannot be internal as it has actions that require client access.\n';
    }

    if (!this.dates_valid && !this.project.repeat) error_message += 'There are date conflicts within the project tasks. Please review the task due dates.\n';

    //Check if the project has tasks with steps that require the client to be active.
    if (this.HasClientActiveSteps() && !this.AllUsersActive()) error_message += 'You have tasks with actions that require the client to be active, but not all clients assigned to the project are active.\n <b>Active clients will have a green check next to their name.</b>\n';

    if (!this.selected_projects.is_internal) {
      // Check if all assigned companies have active default clients with portal access
      let comp_count = 0;
      let client_count = 0;
      this.selected_projects.assigned_companies.forEach(company => {
        if (company.default_client.active == 0) {
          comp_count++;
        }
      });

      // Check if all assigned clients have portal access and are active
      this.selected_projects.assigned_clients.forEach(client => {
        if (client.active == 0) {
          client_count++;
        }
      });
      if (comp_count > 0) error_message += 'All assigned companies must have a default contact with portal access when the project is not marked as internal.<br>';
      if (client_count > 0) error_message += 'All assigned contacts must have portal access and be active when the project is not marked as internal.<br>';
    }

    if (!this.project.all_team_members && this.project.team_members.length == 0) {
      error_message += 'Please assign at least one team member to the project, or select "All Team Members".<br>';
    }

    if (!this.team_members_valid) {
      error_message += 'One or more selected team members do not have permission to access the selected clients.<br>';
    }

    return error_message;
  }

  ProjectDateConfilct(date_in) {
    if ((date_in > this.project.internal_end_date) || date_in < this.project.internal_start_date) return true;
  }
  HasClientActiveSteps() {
    let active_steps = false;
    this.project.tasks.forEach(task => {
      active_steps = this.TaskHasActiveSteps(task);
    });
    return active_steps;
  }
  TaskHasActiveSteps(task) {
    let all_active = false;
    if (task.steps && task.steps.length > 0) {
      task.steps.forEach(step => {
        if (step.type == 1 || step.type == 2 || step.type == 3 || step.type == 4 || step.type == 5 || step.type == 6) {
          all_active = true;
        }
      });
    }
    return all_active;
  }

  AllUsersActive() {
    let all_active = true;
    this.selected_projects.assigned_clients.forEach(client => {
      if (client.active == 0) {
        all_active = false;
      }
    });
    this.selected_projects.assigned_companies.forEach(company => {
      if (company.default_client.active == 0) {
        all_active = false;
      }
    });
    return all_active;
  }

  async AssignProjects() {
    let was_success = true;
    let master_guid = this.globalService.createGUID();

    for (let i = 0; i < this.selected_projects.assigned_clients.length; i++) {
      let schedule_guid = this.globalService.createGUID();
      let project_template_guid = null;
      await this.globalService.presentLoading("Creating for : " + this.selected_projects.assigned_clients[i].display_name, 9999999);
      var client = this.selected_projects.assigned_clients[i];
      let project_copy = JSON.parse(JSON.stringify(this.project));
      //For each client we want to set the project client id
      project_copy.company = null;
      project_copy.client = client;
      if (this.project.repeat) {
        project_template_guid = await this.CreateProjectTemplate(master_guid, "Creating for : " + this.selected_projects.assigned_clients[i].display_name, client.year_end_date, project_copy);
        let schedule_data: any = await this.CreateProjectScheduler(schedule_guid, master_guid, project_template_guid, client, null, project_copy);
      }
      else {
        project_copy.project_scheduler_guid = null;
        let data: any = await this.apiService.post('projects', project_copy);
      }



      await this.globalService.dismissLoading();
    }

    for (let i = 0; i < this.selected_projects.assigned_companies.length; i++) {
      let schedule_guid = this.globalService.createGUID();
      let project_template_guid = null;
      await this.globalService.presentLoading("Creating for : " + this.selected_projects.assigned_companies[i].name, 9999999);
      var company = this.selected_projects.assigned_companies[i];
      let project_copy = JSON.parse(JSON.stringify(this.project));
      //For each client we want to set the project client id
      project_copy.client = null;
      project_copy.company = company;
      if (this.project.repeat) {
        project_template_guid = await this.CreateProjectTemplate(master_guid, "Creating for : " + this.selected_projects.assigned_companies[i].name, company.year_end_date, project_copy);
        let schedule_data: any = await this.CreateProjectScheduler(schedule_guid, master_guid, project_template_guid, null, company, project_copy);
      }
      else {
        project_copy.project_scheduler_guid = null;
        let data: any = await this.apiService.post('projects', project_copy);
      }
      await this.globalService.dismissLoading();
    }
    await this.globalService.dismissLoading();
    console.log('FINISHED!!!!');
    if (was_success) this.modalController.dismiss(true);
  }

  async CreateProjectScheduler(schedule_guid, master_guid, project_template_guid, client, company, project_copy) {
    let start_date = JSON.parse(JSON.stringify(project_copy)).repeat_rules.repeat_start_date;
    //let next_create_date = this.project.internal_start_date;      
    let next_create_date = dayjs(project_copy.repeat_rules.repeat_start_date).add(project_copy.repeat_rules.internal_start_offset, project_copy.repeat_rules.internal_start_offset_unit).format("YYYY-MM-DD");

    console.log("CALCULATED NEXT CREATE DATE", next_create_date);

    let repeat_end_date = '';
    if (project_copy.repeat_rules.end_type == 'never') repeat_end_date = dayjs().add(20, 'year').format('YYYY-MM-DD');
    else if (project_copy.repeat_rules.end_type == 'on') repeat_end_date = dayjs(project_copy.repeat_rules.end_date).format('YYYY-MM-DD');
    else if (project_copy.repeat_rules.end_type == 'after') {
      //Get the last occurrence based on the rules and set the end date
      const windowEnd = dayjs().add(50, 'year').toISOString();
      const occurrences = this.projectsService.buildOccurrences(
        project_copy.repeat_rules,
        project_copy.repeat_start_date,
        project_copy.repeat_start_date,
        windowEnd
      );
      repeat_end_date = occurrences[occurrences.length - 1].format("YYYY-MM-DD");
    }
    let company_guid = null;
    if (company) company_guid = company.guid;
    let client_guid = null;
    if (client) client_guid = client.guid;


    console.log("NEXT CREATE DATE", next_create_date);
    var schedule_info = {
      time_created_guid: schedule_guid,
      master_guid: master_guid,
      project_template_guid: project_template_guid,
      next_create_date: next_create_date,
      start_date: dayjs(start_date).format('YYYY-MM-DD'),
      end_date: repeat_end_date,
      pattern: project_copy.repeat_rules.pattern,
      interval: project_copy.repeat_rules.interval,
      day_of_week: '',
      day_of_month: '',
      repeat_on_start: true,
      client_guid: client_guid,
      company_guid: company_guid,
      project: this.project,
      repeat_rules: JSON.stringify(project_copy.repeat_rules)
    }
    if (company) await this.globalService.presentLoading("Creating for : " + company.name, 9999999);
    if (client) await this.globalService.presentLoading("Creating for : " + client.display_name, 9999999);
    let data: any = await this.apiService.post('projects_schedule', schedule_info);
    return data;
  }

  async CreateProjectTemplate(master_guid, message, YED, project_copy) {
    project_copy.master_guid = master_guid;
    project_copy.template_visible = 0;

    //
    if (project_copy.repeat_rules.relative_date_type == 'year_end_date') {
      if (project_copy.repeat_rules.frequency == 'monthly' || project_copy.repeat_rules.frequency == 'quarterly' || project_copy.repeat_rules.frequency == 'semi-annually') {
        const client_year_end = dayjs(YED);
        const yearEndMonth = client_year_end.month();
        const yearEndDay = client_year_end.date(); ``
        const current_year = dayjs().year();
        const this_year_client_year_end = dayjs().year(current_year).month(yearEndMonth).date(yearEndDay);



        // If this year's year-end date is after the repeat start date, work backwards
        if (this_year_client_year_end.isAfter(dayjs(project_copy.repeat_rules.repeat_start_date))) {
          // Calculate how many intervals back we need to go
          const monthsDiff = this_year_client_year_end.diff(dayjs(project_copy.repeat_rules.repeat_start_date), 'month');
          const intervalsBack = Math.ceil(monthsDiff / project_copy.repeat_rules.interval);

          // Set next_create_date to the earliest valid occurrence
          project_copy.repeat_rules.repeat_start_date = this_year_client_year_end.subtract(intervalsBack * project_copy.repeat_rules.interval, 'month').format("YYYY-MM-DD");
          console.log("CALCULATED NEXT CREATE DATE 111111111", project_copy.repeat_rules.repeat_start_date);
        } else {
          // Use this year's year-end date as the base
          project_copy.repeat_rules.repeat_start_date = this_year_client_year_end.format("YYYY-MM-DD");
          console.log("CALCULATED NEXT CREATE DATE 222222", project_copy.repeat_start_date);
        }

        console.log("CLIENT YEAR END DATE", project_copy.repeat_rules.repeat_start_date);
        project_copy.repeat_rules.monthly_type = 'day';
        project_copy.repeat_rules.monthly_day = yearEndDay;

      }
      else if (project_copy.repeat_rules.frequency == 'yearly') {
        const client_year_end = dayjs(YED);
        const yearEndMonth = client_year_end.month();
        const yearEndDay = client_year_end.date();
        const current_year = dayjs().year();
        const this_year_client_year_end = dayjs().year(current_year).month(yearEndMonth).date(yearEndDay);

        // If this year's year-end date is after the repeat start date, work backwards
        if (this_year_client_year_end.isAfter(dayjs(project_copy.repeat_rules.repeat_start_date))) {
          // Calculate how many intervals back we need to go
          const yearInterval = Math.max(1, project_copy.repeat_rules.interval || 1);
          const yearsDiff = this_year_client_year_end.diff(dayjs(project_copy.repeat_rules.repeat_start_date), 'year');
          const intervalsBack = Math.ceil(yearsDiff / yearInterval);
          project_copy.repeat_rules.repeat_start_date = this_year_client_year_end.subtract(intervalsBack * yearInterval, 'year').format("YYYY-MM-DD");
        } else {
          // Use this year's year-end date as the base
          project_copy.repeat_rules.repeat_start_date = this_year_client_year_end.format("YYYY-MM-DD");
        }

        project_copy.repeat_rules.yearly_month = yearEndMonth + 1; // dayjs months are 0-indexed, yearly_month is 1-indexed
        project_copy.repeat_rules.yearly_day = yearEndDay;
        project_copy.repeat_rules.yearly_use_ordinal = false;

      }




      this.onUpdateDates(project_copy);
      console.log("AFTER ON UPDATE DATES", project_copy.repeat_rules.repeat_start_date);
    }


    this.globalService.presentLoading(message, 99999999999);
    project_copy.validate_tasks = false;
    let data: any = await this.apiService.post('templates/projects', project_copy);
    await this.globalService.dismissLoading();
    //Loop through each client or company and create the project for them
    if (data.success) {
      return data.data;
    }
    else {
      this.globalService.presentToastMessage(data.message, false);
      return null;
    }
  }

  GetAssignmentSize() {
    if (!this.mainContainerRef) return 600 - 1;
    const el = this.mainContainerRef.nativeElement as HTMLElement;
    const rect = el.getBoundingClientRect();
    let allowed_size = Math.round(rect.height);
    return allowed_size - 75;
  }

  async SelectedTemplate(eventData: { data: any }) {
    let selected = eventData.data;
    console.log("SELECTED TEMPLATE FROM CHILD", selected);
    this.project = JSON.parse(selected.json_str);
    if (!this.project.tags) this.project.tags = [];
    if (!this.project.groups) this.project.groups = [];
    if (!this.project.team_members) this.project.team_members = [];
    if (!this.project.hasOwnProperty('all_team_members')) this.project.all_team_members = true;
    // Handle groups
    let group_data = await this.apiService.GetGroups('projects');
    let groups = group_data.data;
    console.log("Project Groups", this.project.groups);
    let groups_we_dont_have = [];
    for (let i = 0; i < this.project.groups.length; i++) {
      const group = this.project.groups[i];
      if (!groups.find(g => g.title === group.title && g.parent_guid === group.parent_guid)) {
        console.log("Group", group);
        groups_we_dont_have.push(group);
      }
      else {
        this.project.groups[i] = groups.find(g => g.title === group.title && g.parent_guid === group.parent_guid);
      }
    }
    if (groups_we_dont_have.length > 0) {
      const alert = await this.alertController.create({
        header: 'Missing Groups',
        message: `This template has groups that are not in your system: ${groups_we_dont_have.map(g => g.title).join(', ')}. Would you like to create these groups now?`,
        buttons: [
          {
            text: 'Skip And Remove',
            role: 'cancel',
            handler: () => {
              return false;
            }
          },
          {
            text: 'Create Groups',
            handler: () => {
              return true;
            }
          }
        ]
      });

      await alert.present();
      const { role } = await alert.onDidDismiss();
      const createGroups = role !== 'cancel';
      console.log("Create Groups:", createGroups);

      if (createGroups) {
        await this.globalService.presentLoading('Creating groups...', 99999999);
        for (const group of groups_we_dont_have) {
          const groupData = {
            title: group.title,
            colour: group.colour || '#90ee90',
            parent_guid: group.parent_guid
          };
          await this.apiService.post('groups/projects', groupData);
        }
        await this.globalService.dismissLoading();
        // Refresh groups list
        group_data = await this.apiService.GetGroups('projects');
        groups = group_data.data;
        // Re-map groups
        for (let i = 0; i < this.project.groups.length; i++) {
          const group = this.project.groups[i];
          const foundGroup = groups.find(g => g.title === group.title && g.parent_guid === group.parent_guid);
          if (foundGroup) {
            this.project.groups[i] = foundGroup;
          }
        }
        this.globalService.presentToastMessage('Groups created successfully', true);
      }
      else {
        // Remove groups that don't exist in the system
        this.project.groups = this.project.groups.filter(group =>
          groups.find(g => g.title === group.title && g.parent_guid === group.parent_guid)
        );
      }
    }

    this.selected_projects.selected_template = selected.guid;
    this.projectsService.FixStartDate(true, this.project.repeat_rules);

  }

  async ChangeProjectDates() {
    let dates_valid = true;
    if (this.project.sync_client_dates) {
      if (!this.project.repeat) {
        this.project.external_start_date = dayjs(this.project.internal_start_date).format("YYYY-MM-DD");
        this.project.external_end_date = dayjs(this.project.internal_end_date).format("YYYY-MM-DD");
      }
    }
    this.project.tasks.forEach(task => {
      console.log("Task: ", task);
      if (task.relative_date) {
        if (task.relative_to_start) {
          console.log("Calculating from start date");
          console.log(this.project.internal_start_date);
          task.start_date = dayjs(this.project.internal_start_date).add(task.start_date_relative, task.start_date_relative_unit).format('YYYY-MM-DD');
          task.due_date = dayjs(this.project.internal_start_date).add(task.due_date_relative, task.due_date_relative_unit).format('YYYY-MM-DD');
        }
        else {
          task.start_date = dayjs(this.project.internal_end_date).add(task.start_date_relative * -1, task.start_date_relative_unit).format('YYYY-MM-DD');
          task.due_date = dayjs(this.project.internal_end_date).add(task.due_date_relative * -1, task.due_date_relative_unit).format('YYYY-MM-DD');
        }
        ApplyUseProjectDates(task, this.project.internal_start_date, this.project.internal_end_date);
        console.log("Calculated due date: ", task.due_date);
        if (task.due_date > this.project.internal_end_date) {
          dates_valid = false;
          this.globalService.presentToastMessage(`Task: ${task.title} is due after the project is due.`, false);
        }
        if (task.due_date < this.project.internal_start_date) {
          dates_valid = false;
          this.globalService.presentToastMessage(`Task: ${task.title} is due before the project is started.`, false);
        }
        // Action due dates are no longer used - just keep the stored value inside its task's dates.
        task.steps.forEach(step => {
          if (step.relative_date) {
            step.due_date = dayjs(task.start_date).add(step.due_date_relative, 'day').format('YYYY-MM-DD');
            if (step.due_date > task.due_date) step.due_date = task.due_date;
            if (step.due_date < task.start_date) step.due_date = task.start_date;
          }
        });
      }
      else {
        if (task.due_date > this.project.internal_end_date) {
          dates_valid = false;
          this.globalService.presentToastMessage(`Task: ${task.title} is due after the project is due.`, false);
        }
        if (task.due_date < this.project.internal_start_date) {
          dates_valid = false;
          this.globalService.presentToastMessage(`Task: ${task.title} is due before the project is started.`, false);
        }
      }

    });



    this.dates_valid = dates_valid;

  }

  //@TODO finish this
  async RemoveGroup(group) {
    this.globalService.RemoveFromArray(this.project.groups, group.guid);
  }

  async RemoveTag(tag) {
    this.globalService.RemoveFromArray(this.project.tags, tag.guid);
  }

  async presentSelectGroupsModal() {
    const modal = await this.modalController.create({
      component: GroupsManagerPage,
      cssClass: 'medium-modal tall-modal secondary-modal',
      backdropDismiss: true,
      componentProps: {
        url: 'projects',
        selection_mode: true,
        max_selection: 999,
        selected_groups: [...this.project.groups],
        modal_title: 'Select Groups'
      }
    });
    modal.onDidDismiss().then((data: any) => {
      if (data && data.data) {
        this.project.groups = data.data;
      }
    });
    return await modal.present();
  }

  async presentSelectTagsModal() {
    let tags_copy = JSON.stringify(this.project.tags);
    const modal = await this.modalController.create({
      component: TagsSelectPage,
      cssClass: 'small-modal tall-modal secondary-modal',
      backdropDismiss: true,
      componentProps: {
        url: 'projects',
        selected_tags: this.project.tags
      }
    })
    modal.onDidDismiss().then((data: any) => {

      if (data && data.data) {
        tags_copy = JSON.parse(tags_copy);
      }
      else {
        this.project.tags = [...JSON.parse(tags_copy)];
      }
    });
    return await modal.present()
  }

  async presentSelectTeamMembers() {
    let team_member_copy = JSON.stringify(this.project.team_members);
    const modal = await this.modalController.create({
      component: TeamMemberSelectPage,
      cssClass: 'small-modal tall-modal secondary-modal',
      backdropDismiss: true,
      componentProps: {
        selecting_for_company: false,
        selecting_for_projects: true,
        selected_team_members: this.project.team_members,
        remove_team_members: this.project.team_members,
        in_team_members: [],
        target_header: 'Currently Selected'
      }
    })
    modal.onDidDismiss().then((data: any) => {
      if (data && data.data) {
        team_member_copy = JSON.parse(team_member_copy);
      }
      else {
        this.project.team_members = [...JSON.parse(team_member_copy)];
      }
      this.ChangeClientsOrTeamMembers();

    });

    return await modal.present()

  }
  async RemoveTeamMember(tm) {
    this.globalService.RemoveFromArray(this.project.team_members, tm.guid);
    this.ChangeClientsOrTeamMembers();

  }

  GetProjectRoleName(role) {
    if(role == 1) return "Leader";
    else if(role == 2) return "Worker";
    else if(role == 3) return "Worker (Alt)";
    else if(role == 4) return "Follower";
  }

  async ChangeClientsOrTeamMembers() {
    console.log('Clients or Team Members Changed');

    // Reset errors
    for (const company of this.selected_projects.assigned_companies) {
      company.permission_error = '';
    }
    for (const client of this.selected_projects.assigned_clients) {
      client.permission_error = '';
    }

    // Shortcut: all team members allowed
    if (this.project.all_team_members) {
      this.team_members_valid = true;
      return;
    }

    let team_members_valid = true;

    for (const teamMember of this.project.team_members) {
      // Ensure cache exists
      (teamMember as any).permissionCache ??= {};
      const cache = (teamMember as any).permissionCache as { [key: string]: boolean };

      // ----- CLIENT PERMISSIONS -----
      for (const client of this.selected_projects.assigned_clients) {
        const cacheKey = `${client.guid}_false`;

        let hasPermission: boolean;

        if (cacheKey in cache) {
          // Use cached result
          hasPermission = cache[cacheKey];
        } else {
          // Fetch + cache
          const response: any = await this.apiService.get(
            `team_members/${teamMember.guid}/permissions/${client.guid}/false`
          );
          hasPermission = response.success;
          cache[cacheKey] = hasPermission;
        }

        if (!hasPermission) {
          team_members_valid = false;
          client.permission_error =
            (client.permission_error || '') +
            (client.permission_error ? ', ' : '') +
            teamMember.display_name;
        }
      }

      // ----- COMPANY PERMISSIONS -----
      for (const company of this.selected_projects.assigned_companies) {
        const cacheKey = `${company.guid}_true`;

        let hasPermission: boolean;

        if (cacheKey in cache) {
          hasPermission = cache[cacheKey];
        } else {
          const response: any = await this.apiService.get(
            `team_members/${teamMember.guid}/permissions/${company.guid}/true`
          );
          hasPermission = response.success;
          cache[cacheKey] = hasPermission;
        }

        if (!hasPermission) {
          team_members_valid = false;
          company.permission_error =
            (company.permission_error || '') +
            (company.permission_error ? ', ' : '') +
            teamMember.display_name;
        }
      }
    }

    this.team_members_valid = team_members_valid;
  }



  async Close() {
    this.modalController.dismiss();
  }
}
